module.exports = __webpack_public_path__ + "media/categories/9002-620a3541.svg";